import { render, staticRenderFns } from "./AllAccountsTab.vue?vue&type=template&id=35f3767e"
import script from "./AllAccountsTab.vue?vue&type=script&lang=js"
export * from "./AllAccountsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports